module.exports = __webpack_public_path__ + "img/clarus-logo.b32250c1.png";